import React from 'react'
import { css } from '@linaria/core'
import { ArrowCaret } from '@fs/zion-icon'
import { colors, Row } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'

const lessButton = css`
  display: flex;
  align-items: center;
  color: ${colors.transparent.gray70};
  background: none;
  border: none;
  font-size: 14px;
  margin-inline-start: -5px;

  &:hover,
  &:focus {
    text-decoration: underline;
  }
  span {
    margin-inline-end: 8px;
  }
`

export default function FooterExpansionButton({ onClick }) {
  const { t } = useTranslation()

  return (
    <Row alignX="end">
      <button
        className={lessButton}
        type="button"
        onClick={onClick}
        name="footer_less"
        aria-label={t('footer.collapse', 'Collapse footer - less')}
      >
        <span>{t('common-ui:show-less.info.abbr', 'Less')}</span>
        <ArrowCaret background={colors.transparent.gray70} color="white" size="xs" direction="up" />
      </button>
    </Row>
  )
}
